module.exports = __webpack_public_path__ + "static/media/Hormone & Endocrinology.7537d4e9.png";